import axios from "axios";
import {ResponseList} from "../../models/clientModels/interfaces/Response";

import {EDCurriculum} from "../../models/serverModels/education/EDCurriculum";
import {EDMyEvalParams} from "../../models/serverModels/education/EDMyEval";

const education = axios.create({
  baseURL: "/API",
});

export const getList = async (params: EDMyEvalParams): Promise<ResponseList<EDCurriculum>> =>
  education({
    url: "/EvalList",
    method: "get",
    params,
  }).then((res) => res.data);
export const getTrialCount = async (
  params: number
): Promise<{trialCount: number; isAuth: boolean}> =>
  education({
    url: `/curriculum/getTrialCount/${params}`,
    method: "get",
    params,
  }).then((res) => res.data);
